export default {
  props: {
	config: {
	  type: Object,
	  required: true
	},
	preview: {
	  type: Boolean,
	}
  },
};
